import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true, wheelMultiplier: 1 }}>
      <div className="relative min-h-screen">
        <div className="noise-overlay" aria-hidden="true" />
        <Navbar />
        <main className="relative z-10">
          <Outlet />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}
